import { render, staticRenderFns } from "./vendor-form.vue?vue&type=template&id=ec6a98d8&"
import script from "./vendor-form.vue?vue&type=script&lang=js&"
export * from "./vendor-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vendor-form.vue"
export default component.exports